var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLevel3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.551,
  height: 17.49
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "level3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.551v17.49H0z",
  "data-name": "Rectangle 18368"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#level3_svg__a)",
  "data-name": "Group 644063"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.551 2H10.135a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647970"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.551 5.872H10.135a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647971"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.551 9.745H10.135a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647972"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.551 13.618H10.135a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647973"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.551 17.49H10.135a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647974"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M.322 12.67a3.46 3.46 0 0 0 1.7.466 1.8 1.8 0 0 0 1.884-1.971 2.03 2.03 0 0 0-2.26-2.1h-.32V7.652h.233a1.856 1.856 0 0 0 2.026-1.757A1.378 1.378 0 0 0 2.15 4.354a2.63 2.63 0 0 0-1.452.5L.376 3.422a4.1 4.1 0 0 1 2.259-.645A2.648 2.648 0 0 1 5.5 5.519a2.87 2.87 0 0 1-1.7 2.67v.036a2.94 2.94 0 0 1 2.026 3.011 3.43 3.43 0 0 1-3.657 3.477A4.35 4.35 0 0 1 0 14.176Z",
  "data-name": "Path 647975"
}))));
export { SvgLevel3 as ReactComponent };
export default __webpack_public_path__ + "bed1e6788feb7b714cd875867354f241.svg";